// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3HrxQ","clinicsSelect":"TableHeading_clinicsSelect__1vNHz"};